export default __webpack_public_path__ + "static/featured-blog-1-b9e7f048ef491f07afd5c1fe476c938f.png";